import React from 'react';
import { Dropzone as RapydDropzone } from '@rapyd/react-ui-library';
import { DropzoneProps } from '@rapyd/react-ui-library/dist/components/Dropzone';
import { ThemeBreakpoints } from 'models';

export type IDropzoneProps = DropzoneProps

export interface FileOptions extends File {
  path?: string;
  token?: string;
  deleted?: boolean;
}

const Dropzone = ({
  className,
  name,
  staticSize = ThemeBreakpoints.LARGE,
  ...rest
}: IDropzoneProps) => {
  return (
    <RapydDropzone
      className={className}
      name={name || 'dropzone'}
      staticSize={staticSize}
      {...rest}
    />
  );
};

export default Dropzone;
